import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {ComponentsModule} from '../../components/components.module';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxMatomoTrackerModule} from 'ngx-matomo-client';
import {ConsumptionComponent} from "./consumption.component";
import { ConsumptionBarGraphComponent } from './consumption-bar-graph/consumption-bar-graph.component';
import {NgxChartsModule} from "@swimlane/ngx-charts";
import {ConsumptionLineGraphComponent} from "./consumption-line-graph/consumption-line-graph.component";
import { GaugeComponent } from './gauge/gauge.component';

const secondaryRoutes: Routes = [
  {
    path: '',
    component: ConsumptionComponent
  },
];

@NgModule({
    declarations: [
        ConsumptionComponent,
        ConsumptionBarGraphComponent,
        ConsumptionLineGraphComponent,
        GaugeComponent,
    ],
    exports: [
        ConsumptionComponent
    ],
    imports: [
        RouterModule.forChild(secondaryRoutes),
        CommonModule,
        ComponentsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        NgbModule,
        NgxMatomoTrackerModule,
        FormsModule,
        NgxChartsModule]
})
export class ConsumptionModule {
}
